export const GET_SUBZONES = 'GET_SUBZONES'
export const GET_SUBZONES_EXITO = 'GET_SUBZONES_EXITO'
export const GET_SUBZONES_ERRROR = 'GET_SUBZONES_ERROR'
